export const setcurrentTab = (tab) => ({
  type: "SET_CURRENT_TAB",
  payload: tab,
});
